export interface Filiale {
	id: string;
	name: string;
	image: string;
	mapImage: string;
	strasse: string;
	plz: string;
	ort: string;
	oeffnungszeiten: string[];
	link: string;
}

export const filialen: Filiale[] = [
	{
		id: "buehl",
		name: "Bühl",
		image: "img/aussenansicht-hoergut-buehl.webp",
		mapImage: "img/karte-hoergut-buehl.webp",
		strasse: "Hüfflischer Hof 13",
		plz: "77815",
		ort: "Bühl",
		oeffnungszeiten: [
			"Mo - Fr: 09:00 - 18:00 Uhr",
			"Sa: 09:00 - 12:00 Uhr",
			"Oder Termin nach Absprache"
		],
		link: "https://www.google.com/maps/place/H%C3%BCfflischer+Hof+13,+77815+B%C3%BChl/@48.6950919,8.1369022,196m/data=!3m1!1e3!4m6!3m5!1s0x4796df60f15e20af:0x91cb7e3b3692e555!8m2!3d48.695041!4d8.1376721!16s%2Fg%2F11rg5y804z?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D",
	},
	{
		id: "Rheinau",
		name: "Rheinau",
		image: "img/hoergut-rheinau-bischofsheim-aussenansicht.webp",
		mapImage: "img/karte-hoergut-rheinau.webp",
		strasse: "Renchener Str. 1a",
		plz: "77866",
		ort: "Rheinau",
		oeffnungszeiten: [
			"Mi: 09:00 - 12:00 Uhr",
			"Sa: 14:00 - 16:00 Uhr",
		],
		link: "https://www.google.com/maps/place/Renchener+Str.+1a,+77866+Rheinau/@48.6532219,7.9262275,250m/data=!3m1!1e3!4m6!3m5!1s0x4796c4d3667bed79:0x3013b58f717637ce!8m2!3d48.653176!4d7.926773!16s%2Fg%2F11pw15bq3w?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D",
	}
];
